<template>
    <div v-if="show" class="progress">
        <div class="progress_box">
            <div class="progress_title">
                <span>提示</span>
            </div>
            <img src="../../../static/img/loading2.gif" alt="">
            <span>请稍后,程序正在运行</span>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            colors: '#f56c6c'
        }
    },
    watch: {},
    props: {
        show: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
.progress {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99999;
    background: rgba(0, 0, 0, 0.3)
}

.progress > .progress_box {
    margin: 200px auto 0px;
    text-align: center;
    width: 420px;
    background: #fff;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
}

.progress > .progress_box > span {
    font-size: 14px;
    margin-bottom: 20px;
    display: block;
    height: 13px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    padding-bottom: 40px;
}
.progress > .progress_box > .progress_title{
    height: 45px;
    background: #F6F7FB;
    border-radius: 3px 3px 0px 0px;
    line-height: 45px;
    text-align: left;
    padding-left: 20px;
}
.progress > .progress_box > .progress_title > span{

    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}
.progress_text {
    display: flex;
    justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/elementCommen/elProgress.vue